import React from 'react';
import PropTypes from 'prop-types';
import Notification from '@tds/core-notification';
import { Text } from '../orderDetails/css';

const MessageNotification = ({ message, variant }) => (
  <Notification variant={variant}>
    <Text bold>{message}</Text>
  </Notification>
);

MessageNotification.propTypes = {
  message: PropTypes.string.isRequired,
  variant: PropTypes.string.isRequired
};
export default MessageNotification;
